(function () {
  'use strict';

  function initHero(hero) {
    if (!hero || hero.dataset.zsHomeReady === 'true') return;
    hero.dataset.zsHomeReady = 'true';

    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-zs-home-slide]'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-zs-home-dot]'));
    var prev = hero.querySelector('[data-zs-home-prev]');
    var next = hero.querySelector('[data-zs-home-next]');
    var toggle = hero.querySelector('[data-zs-home-toggle]');
    if (slides.length < 2) return;

    var index = 0;
    var timer = null;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = hero.dataset.autoplay === 'true' && !reduceMotion;
    var manuallyPaused = false;
    var speed = Math.max(3, Number(hero.dataset.speed || 6)) * 1000;

    if (toggle && !autoplay) toggle.hidden = true;

    function show(nextIndex, focusDot) {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.toggleAttribute('inert', !active);
        slide.querySelectorAll('video').forEach(function (video) {
          if (active && !reduceMotion) video.play().catch(function () {});
          else video.pause();
        });
      });
      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if (focusDot && dots[index]) dots[index].focus();
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      if (autoplay && !manuallyPaused) timer = window.setInterval(function () { show(index + 1, false); }, speed);
    }

    function updateToggle() {
      if (!toggle) return;
      toggle.setAttribute('aria-pressed', manuallyPaused ? 'true' : 'false');
      toggle.setAttribute('aria-label', manuallyPaused ? 'Reanudar reproducción automática' : 'Pausar reproducción automática');
      toggle.textContent = manuallyPaused ? '▶' : 'Ⅱ';
    }

    if (prev) prev.addEventListener('click', function () { show(index - 1, false); start(); });
    if (next) next.addEventListener('click', function () { show(index + 1, false); start(); });
    dots.forEach(function (dot, dotIndex) {
      dot.addEventListener('click', function () { show(dotIndex, false); start(); });
    });
    if (toggle) toggle.addEventListener('click', function () {
      manuallyPaused = !manuallyPaused;
      updateToggle();
      if (manuallyPaused) stop();
      else start();
    });
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', start);
    hero.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') show(index - 1, true);
      if (event.key === 'ArrowRight') show(index + 1, true);
    });
    show(0, false);
    updateToggle();
    start();
  }

  function initCarousel(carousel) {
    if (!carousel || carousel.dataset.zsHomeReady === 'true') return;
    carousel.dataset.zsHomeReady = 'true';
    var track = carousel.querySelector('[data-zs-home-track]');
    var controlsScope = carousel.closest('.zs-home-section') || carousel.parentElement;
    var prev = controlsScope ? controlsScope.querySelector('[data-zs-home-carousel-prev]') : null;
    var next = controlsScope ? controlsScope.querySelector('[data-zs-home-carousel-next]') : null;
    if (!track) return;
    var timer = null;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = carousel.dataset.autoplay === 'true' && !reduceMotion;
    var speed = Math.max(3, Number(carousel.dataset.speed || 5)) * 1000;

    function amount() {
      var slide = track.querySelector('.zs-home-slide');
      if (!slide) return track.clientWidth;
      return slide.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 16);
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = max <= 2 || track.scrollLeft >= max - 2;
    }

    function goNext() {
      var max = track.scrollWidth - track.clientWidth;
      if (track.scrollLeft >= max - 2) track.scrollTo({ left: 0, behavior: 'smooth' });
      else track.scrollBy({ left: amount(), behavior: 'smooth' });
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      if (autoplay && track.scrollWidth > track.clientWidth + 2) timer = window.setInterval(goNext, speed);
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -amount(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', goNext);
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', start);
    update();
    start();
  }

  function init(root) {
    (root || document).querySelectorAll('[data-zs-home-hero]').forEach(initHero);
    (root || document).querySelectorAll('[data-zs-home-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
